import {ChangeDetectionStrategy, Component, computed, input, InputSignal} from '@angular/core';
import {RouterLink} from '@angular/router';
import {DatePipe} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';

import {TournamentModel} from 'shared/models';
import {DataShape} from '../list/list';

@Component({
  selector: 'tournaments-ui',
  standalone: true,
  imports: [RouterLink, DatePipe, MatCardModule, MatMenuModule, MatButtonModule, MatTableModule, MatPaginatorModule, MatTooltipModule],
  templateUrl: './list-ui.html',
  styleUrl: './list-ui.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListUi {
  tournaments: InputSignal<DataShape['tournaments'] | undefined> = input.required<DataShape['tournaments'] | undefined>();

  protected displayedColumns: string[] = ['name', 'event', 'location', 'modality', 'startDate', 'endDate', 'options'];

  protected dataSource = computed((): MatTableDataSource<TournamentModel> => {
    return new MatTableDataSource<TournamentModel>(this.tournaments()?.list);
  });

  // Search Filter
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource().filter = filterValue.trim().toLowerCase();
  }

  onChangeStatus(event: any) {
    console.info('onChangeStatus', event);
  }
}
